// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import { CLS_PREFIX } from '../../constants';
import Button from '../Button';
import Icon from '../Icon';

const CardButton = ({ icon, ...props }) => (
    <Button icon={Icon.create(icon)} {...props} />
);

CardButton.propTypes = {
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]).isRequired,
};

CardButton.defaultProps = {
    baseClassName: `${CLS_PREFIX}card-button`,
};

export default CardButton;



// WEBPACK FOOTER //
// ./components/Card/CardButton.js